import { EmphasizedContentCard } from 'ui/components';

export const EmphasizedContentCardFeature: React.FC<Content.EmphasizedContentCard> = ({
    settings,
    content,
}) => {
    const {
        orientation,
        backgroundColor,
    } = settings?.properties ?? {};

    const resolvedOrientation =
        orientation === 'Block' ? 'Block' : 'Vertical';

    return (
        <EmphasizedContentCard
            {...content?.properties}
            orientation={resolvedOrientation}
            backgroundColor={backgroundColor}
            image={
                content?.properties?.image
                    ? {
                          url: content.properties.image.url,
                          altText: content.properties.image.properties.altText,
                          focalPoint: content.properties.image.focalPoint,
                      }
                    : null
            }
        />
    );
};